import PropTypes from 'prop-types';

/**
 * Business name item definition
 * Follows same structure as BusinessIdea for consistency with ReportPanel
 * Supports both 'name' and 'title' keys for flexibility
 */
export const BusinessNameItem = PropTypes.shape({
  id: PropTypes.string,
  // Either name or title should be present
  name: PropTypes.string,
  title: PropTypes.string,
  report: PropTypes.oneOfType([
    // Backend structure with sections array
    PropTypes.shape({
      sections: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          title: PropTypes.string.isRequired,
          content: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array])
            .isRequired,
          component: PropTypes.string
        })
      )
    }),
    // Flexible object structure
    PropTypes.object
  ])
});

/**
 * Business name results data structure
 * Expects an 'items' array
 * @param {object} props - Component props
 * @param {string} propName - Name of the prop being validated
 * @param {string} componentName - Name of the component
 * @returns {Error|null} Validation error or null if valid
 */
export const BusinessNameResultsData = (props, propName, componentName) => {
  // eslint-disable-next-line react/destructuring-assignment -- Dynamic property access required for PropType validator
  const data = props[propName];

  if (!data) {
    return new Error(`The prop '${propName}' is required in '${componentName}'.`);
  }

  const hasItems = Array.isArray(data.items) && data.items.length > 0;

  if (!hasItems) {
    return new Error(
      `The prop '${propName}' in '${componentName}' must have an 'items' array with at least one element.`
    );
  }

  return null;
};

/**
 * Main BusinessNameResults props
 */
export const BusinessNameResultsProps = PropTypes.shape({
  data: BusinessNameResultsData,
  onComponentClick: PropTypes.func
});
